/**
 * Try to shorten a string to a sentence end close to the given length
 * or cut it off at the given length if no sentence end is near enough.
 *
 * @param str String to shorten
 * @param maxLength
 * @returns
 */
export default function shortenToSentenceEndOrLength(
  str: string,
  maxLength: number = 150
): string {
  str = str.trim();

  if (str.length <= maxLength) {
    return str;
  }

  let maxSentenceEnd = 0;
  for (const char of [".", "!", "?", ":", ";"]) {
    const index = str.lastIndexOf(char);
    if (index > maxSentenceEnd && index < maxLength) {
      maxSentenceEnd = index;
    }
  }

  if (maxSentenceEnd > 0 && maxSentenceEnd > maxLength - 20) {
    return str.substring(0, maxSentenceEnd).trim() + ".";
  }
  return str.substring(0, maxLength - 3).trim() + "...";
}
